module.exports = __webpack_public_path__ + "h5/img/biao_1.939abb7b.jpg";